// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"119":"view-agent-request","561":"kyc-signups","798":"payment-wallet","966":"dashboard"}[chunkId] + "." + {"119":"46519b9c","561":"9a4c406f","798":"e8036663","966":"26022c4e"}[chunkId] + ".js";
};